import React, {useState} from "react";
import ReactFlow, {addEdge, Background, Controls, ReactFlowProvider, removeElements,} from 'react-flow-renderer';
import {
    Avatar,
    Button,
    Col,
    Divider, Drawer,
    Form,
    Input, message,
    Modal,
    Row,
    Select,
    Slider,
    Space,
    Tabs,
    Tooltip,
    Typography
} from "antd";
import {inject, observer} from "mobx-react";
import {ApartmentOutlined, ControlOutlined, FileTextOutlined, InfoCircleTwoTone} from "@ant-design/icons";
import {DashboardPageSimple} from "./DashboardPage";
import {CartesianGrid, Legend, Line, LineChart, Tooltip as ChartTooltip, XAxis, YAxis} from "recharts";
import {colors} from "../components/Common/Colors";
import {Link} from "react-router-dom";
import Model from "../Modeling/Model";
import {SectionCard} from "../components/ui/SectionCard";
import {ChartBox} from "../Modeling/ChartBox";
import {axisProps, chartPalette, gridProps} from "../components/ui/tokens";
import {StrategyParam} from "../components/Modeling/StrategyParam";
import {TargetsDrawer} from "../components/Modeling/TargetsDrawer";
import {useIsNarrow} from "../hooks/breakpoint.hook";
import {REGIONS} from "../Modeling/regions";
import {NodeModal} from "../components/Modeling/NodeModal";
import {OverviewFlow} from "../components/Modeling/FlowDiagram";
import {StrategyEditor} from "../components/Modeling/StrategyEditor";

import {models} from "../Modeling/registry";
import {useParams} from "react-router";
import {isNaN} from "lodash";



const DashboardFixed = inject('dashboard')(observer(({dashboard, wd}) => {
    dashboard.insureServer(wd)
    const cnt = dashboard.items ? dashboard.items.length : 0;
    return (
        <DashboardPageSimple data={dashboard} isInEditorMode={false}>{cnt}</DashboardPageSimple>
    )
}))

function AreaSelect({setRegion}) {
    return <Select defaultValue={"1100"} style={{width: "100%"}} showSearch optionFilterProp={"children"}
                   onChange={(value => setRegion(value))}>
        {REGIONS.map(({code, title}) => <Select.Option key={code} value={code}>{title}</Select.Option>)}
    </Select>;
}

const DemoPage = () => {
    const [cp, setCp] = useState({y5f2022: 56.7, y5f2023: 57.2, y5f2024: 60.0, y1f2022: 19.0, y1f2023: 18.1, y1f2024: 17.3})
    const [formCp] = Form.useForm()
    const {modelName} = useParams()
    const [region, setRegion] = useState('1100')
    console.log('model', modelName)
    const model = models[modelName]
    console.log('model-in', model)




        const [visible, setVisible] = useState(false);

        const showDrawer = () => {
            setVisible(true);
        };

        const onClose = () => {
            setVisible(false);
        };

    const [strategy, setStrategy] = useState(model?.defaultStrategy)

    console.log('ds', strategy)

    const [params,     setParams] = useState({})
    const [mutation, setMutation] = useState({})
    const [showLeft, setShowLeft] = useState(true)

    const [modalVisible, setModalVisible] = useState(false)
    const [crVisible, setCrVisible] = useState(false)
    const [scenarioOpen, setScenarioOpen] = useState(false)

    // на узком экране сценарий не помещается рядом с результатами: там он
    // открывается снизу как отдельная панель, на широком — сворачивает колонку
    const isNarrow = useIsNarrow()

    // ссылка на клинические рекомендации берётся с любого узла модели, где она задана
    const modelCr = model?.stepOption?.find(item => item.cr)?.cr

    if (!model)
        return "Модель ещё не создана"


    const initialElements = [...model.stepOption.map((item) => ({
            id: item.value,
            type: item.type,
            // класс по типу узла: заболеваемость, стадия, терапия — разный акцент
            className: `flow-card flow-card--${item.typex || item.type || 'plain'}`,
            data: {label: <NodeModal item={item} model={model}/>},
            isNode: true,
            position: {
                x: ((200 * item.col) || 400) - 125 + 50, y: Number(item.level - 1) * 90},
        })
    ), ...model.stepConnection.map(item => ({
        ...item,
        id: "e" + item.source + '-' + item.target,
        animated: true,
    })).map(item => {
        if (item.mutator && strategy[item.mutator.name])
        {
            if (item.mutator.negative)
            {
                item.sender.value = 1 - strategy[item.mutator.name] / 100
            } else {
                item.sender.value = strategy[item.mutator.name] / 100
            }
        }
        return item
    } ).map(item => ({...item, label: item.hideLabel ? '' : (item?.sender?.value ? Math.round(item?.sender?.value * 100) + '%' : item.label)}))
    ]

    return (<div className={"page-stack"}>
        <div className={"page-head"}>
            <div style={{minWidth: 0}}>
                <Typography.Title level={3} style={{margin: 0, fontWeight: 600}}>{model.name}</Typography.Title>
                <Typography.Text type={"secondary"}>
                    Цифровой двойник потока пациентов: сценарии терапии и их последствия
                </Typography.Text>
            </div>
            <Space wrap>
                <Tooltip title={modelCr ? "Клинические рекомендации" : "Клинические рекомендации не загружены"}>
                    <Button icon={<FileTextOutlined/>} disabled={!modelCr}
                            onClick={() => setCrVisible(true)}>Рекомендации</Button>
                </Tooltip>
                <Button icon={<ApartmentOutlined/>} onClick={() => setModalVisible(true)}>Схема потока</Button>
                <Button icon={<ControlOutlined/>}
                        type={!isNarrow && !showLeft ? 'primary' : 'default'}
                        onClick={() => isNarrow ? setScenarioOpen(true) : setShowLeft(!showLeft)}>
                    {isNarrow ? 'Сценарий' : (showLeft ? 'Свернуть сценарий' : 'Развернуть сценарий')}
                </Button>
                <Button type={"primary"} onClick={showDrawer}>Целевые показатели</Button>
            </Space>
        </div>

            <TargetsDrawer visible={visible} onClose={onClose} form={formCp} values={cp} onChange={setCp}/>

        <SectionCard bodyStyle={{padding: 12}}>
            <Row gutter={[12, 12]} align={"middle"} wrap>
                <Col xs={24} md={10} lg={8}>
                    <Typography.Text type={"secondary"} style={{fontSize: 12, display: 'block'}}>Территория</Typography.Text>
                    <AreaSelect setRegion={setRegion}/>
                </Col>
                <Col xs={24} md={6} lg={4}>
                    <Typography.Text type={"secondary"} style={{fontSize: 12, display: 'block'}}>Год</Typography.Text>
                    <Input defaultValue={"2022"}/>
                </Col>
            </Row>
        </SectionCard>
        <Row gutter={[16, 16]}>
            <Col xs={0} lg={showLeft ? 10 : 0}>
                <Modal width={"95%"} style={{top: 8, maxWidth: '100vw'}} visible={modalVisible}
                       onOk={() => setModalVisible(false)} onCancel={() => setModalVisible(false)}>
                    <Typography.Title level={4}>Модель потока пациентов</Typography.Title>
                    <Tabs style={{height: '80vh'}} defaultActiveKey={"2"} tabBarExtraContent={{
                        left: <Tooltip title={modelCr
                            ? "Клинические рекомендации"
                            : "Клинические рекомендации для этой модели не загружены"}>
                            <Button type={"primary"} style={{margin: "10px"}} disabled={!modelCr}
                                    onClick={() => setCrVisible(true)}>CR</Button>
                        </Tooltip>
                    }}>
                        <Tabs.TabPane tab={"Диагностика"} disabled key={1}/>
                        <Tabs.TabPane tab={"Лечение"} key={2}>
                            <div style={{height: "68vh", margin: "8px 0"}}>
                                <OverviewFlow initialElements={initialElements}
                                              key={strategy.M1 + ':' + strategy.M2}/>
                            </div>
                            <div className={"flow-legend"}>
                                <span className={"flow-legend__item"}>
                                    <span className={"flow-legend__swatch"} style={{background: '#2563eb'}}/>
                                    Выявление
                                </span>
                                <span className={"flow-legend__item"}>
                                    <span className={"flow-legend__swatch"} style={{background: '#0ea5a4'}}/>
                                    Стадии и группы
                                </span>
                                <span className={"flow-legend__item"}>
                                    <span className={"flow-legend__swatch"} style={{background: '#7c3aed'}}/>
                                    Схемы терапии
                                </span>
                                <span className={"flow-legend__item"}>
                                    Нажмите на элемент, чтобы увидеть его данные и связи
                                </span>
                            </div>
                        </Tabs.TabPane>
                        <Tabs.TabPane tab={"Реабилитация"} disabled key={3}/>
                        <Tabs.TabPane tab={"Паллиатив"} disabled key={4}/>
                    </Tabs>
                </Modal>
                <Modal title={`Клинические рекомендации: ${model.name}`} visible={crVisible} width={"95%"}
                       style={{top: 8, maxWidth: '100vw'}} footer={null}
                       onCancel={() => setCrVisible(false)} bodyStyle={{padding: 8}}>
                    {modelCr && <iframe title={"Клинические рекомендации"} src={modelCr}
                                        style={{width: '100%', height: '80vh', border: 0}}/>}
                </Modal>
                <SectionCard title={"Сценарий"}
                             description={"Доли пациентов на таргетной терапии: А — текущая практика, В — целевой сценарий"}>
                    <StrategyEditor setStrategy={setStrategy} strategy={strategy} vars={model.vars}
                                    model={model} region={region}/>
                </SectionCard>
            </Col>

            <Drawer title={"Сценарий"} placement={"bottom"} height={"85vh"} bodyStyle={{padding: 16}}
                    visible={isNarrow && scenarioOpen} onClose={() => setScenarioOpen(false)}>
                <Typography.Paragraph type={"secondary"} style={{fontSize: 13}}>
                    Доли пациентов на таргетной терапии: А — текущая практика, В — целевой сценарий.
                    Результаты пересчитываются сразу.
                </Typography.Paragraph>
                <StrategyEditor setStrategy={setStrategy} strategy={strategy} vars={model.vars}
                                model={model} region={region}/>
            </Drawer>
            <Col xs={24} lg={showLeft ? 14 : 24}>
                <SectionCard bodyStyle={{padding: 16}}>
                <Model strategy={strategy} mutation={mutation} params={params} flow={{
                    steps: model.stepOption,
                    connections: model.stepConnection,
                    economics: model.economics,
                    modeling: model.modeling,
                    mainTrends: model.mainTrends
                }} options={model.options} cp={cp}
                       region={region} name={model.name}
                />
                {
                    //    <DashboardFixed wd={"default"}/>
                }
                </SectionCard>
            </Col>
        </Row>
    </div>)}

export default DemoPage